import React from 'react'
import './index.css'

export default function BlockScreen(props: any) {
  const openBlockScreen = props.openBlockScreen
  return openBlockScreen && (
    <React.Fragment>
      <div className="cover-loading-bar">
        <div className="loading-bar"></div>
      </div>
    </React.Fragment>
  )
};

interface ModalOverlayProps {
  show: boolean
  onClose: () => void
}

export const ModalOverlay: React.FC<ModalOverlayProps> = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  const handleOverlayClick = (e: any) => {
    // Check if the clicked element is the overlay (not the modal content)
    if (e.target.className === 'modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick} />
  );
}

